import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import ServicesCard from "./ServicesCard";
import ProjectCard from "./ProjectCard";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import webDevlopment from "./assets/img/web-developments.jpg";
import ApplicationDevlopment from "./assets/img/application.png";
import DigitalMarketing from "./assets/img/digital-marketing.jpg";
import Seo from "./assets/img/seo.jpg";
import cloud from "./assets/img/cloud.png";
import AI from "./assets/img/ai.png";
import colorSharp2 from "./assets/img/color-sharp2.png";

import TrackVisibility from 'react-on-screen';
import { Helmet } from 'react-helmet';
import ConnectForm from './ConnectForm';
import './style/Services.css';

const Services = ({ onConnectClick }) => {
  const [formVisible, setFormVisible] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [error, setError] = useState(null);

  const services = [
    { title: "Application Development", imgUrl: ApplicationDevlopment },
    { title: "Web Development", imgUrl: webDevlopment },
    { title: "Digital Marketing", imgUrl: DigitalMarketing },
    { title: "SEO Services", imgUrl: Seo },
    { title: "Cloud Services", imgUrl: cloud },
    { title: "AI-ML Services", imgUrl: AI },
  ];

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch("https://backend.ytctechventures.com/admin/getProjectList");
        const data = await response.json();
        if (data && data.projectList) {
          const formattedProjects = data.projectList.map((project, index) => ({
            title: project.projectName,
            link: `#project-${project.projectId}`,
            description: [project.description],
            reverseLayout: index % 2 !== 0,
            thumbnail: project.projectThumbnail
          }));
          setProjects(formattedProjects);
        } else {
          throw new Error("Invalid API response structure.");
        }
      } catch (err) {
        setError("Unable to load projects. Please try again later.");
      } finally {
        setLoadingProjects(false);
      }
    };

    fetchProjects();
  }, []);

  const handleCloseForm = () => setFormVisible(false);

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 3 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
  };

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Our Services - YTC TechVenture</title>
        <meta name="description" content="Discover the wide range of services we offer at YTC TechVenture..." />
        <meta name="keywords" content="Application Development, Web Development, Digital Marketing, SEO Services..." />
        <meta name="author" content="YTC TechVenture" />
        <meta property="og:title" content="Our Services - YTC TechVenture" />
        <meta property="og:description" content="Discover the wide range of services we offer..." />
      </Helmet>

      <section className="service" id="services">
        <Container>
          <Row>
            <Col>
              <TrackVisibility>
                {({ isVisible }) =>
                  <div className={isVisible ? "animate__animated animate__fadeIn text-center" : "text-center"}>
                    <h2 style={{ color: 'white' }}>Our Services</h2>
                    <div className="mb-4"></div>
                    <Row>
                      {services.map((service, index) => (
                        <ServicesCard key={index} {...service} />
                      ))}
                    </Row>
                  </div>
                }
              </TrackVisibility>
            </Col>
          </Row>
        </Container>
        <img className="background-image-right" src={colorSharp2} alt="Background" />
      </section>

      <section className="projects-section" style={{ padding: '40px 0' }}>
        <Container>
          <h2 className="project-title text-center mb-4">Our Work</h2>

          {loadingProjects ? (
            <p className="text-center">Loading projects...</p>
          ) : error ? (
            <p className="text-danger text-center">{error}</p>
          ) : (
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={1500}
              arrows={false}
              showDots={false}
              draggable={true}
              swipeable={true}
              keyBoardControl={true}
              containerClass="carousel-container"
              removeArrowOnDeviceType={["tablet", "mobile"]}
              itemClass="carousel-item-padding-40-px"
            >
              {projects.map((project, index) => (
                <div key={index} style={{ padding: "0 10px" }}>
                  <ProjectCard project={project} />
                </div>
              ))}
            </Carousel>
          )}
        </Container>
      </section>

      <ConnectForm visible={formVisible} onClose={handleCloseForm} />
    </>
  );
};

export default Services;
